import { visuallyHiddenStyle } from './VisuallyHidden.styles.css';
import { PropsWithChildren } from 'react';

export function VisuallyHidden(props: PropsWithChildren) {
    return (
        <div className={visuallyHiddenStyle} {...props}>
            {props.children}
        </div>
    );
}
